module.exports = __webpack_public_path__ + "media/images/lig/shirt-carousel/shirt-08-68a320d6a54cd3b1ca8362bb9509cd02.jpg";